"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyHelper = void 0;
class PropertyHelper {
    static ReduceProperty(Value, PropertyPath) {
        let o = Value;
        if (PropertyPath) {
            PropertyPath = PropertyPath.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            PropertyPath = PropertyPath.replace(/^\./, ''); // strip a leading dot
            const a = PropertyPath.split('.').filter((r) => r);
            for (let i = 0, n = a.length; i < n; ++i) {
                const k = a[i];
                if (o && k in o) {
                    o = o[k];
                }
                else {
                    return;
                }
            }
        }
        return o;
    }
    static SetProperty(Value, PropertyPath, NewValue) {
        if (PropertyPath) {
            let o = Value;
            PropertyPath = PropertyPath.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            PropertyPath = PropertyPath.replace(/^\./, ''); // strip a leading dot
            const a = PropertyPath.split('.').filter((r) => r);
            for (let i = 0, n = a.length - 1; i < n; ++i) {
                const k = a[i];
                if (k in o) {
                    o = o[k];
                }
                else {
                    return;
                }
            }
            if (a.length > 0) {
                if (!o) {
                    o = {};
                }
                o[a[a.length - 1]] = NewValue;
            }
            else {
                o = NewValue;
            }
        }
    }
}
exports.PropertyHelper = PropertyHelper;
//# sourceMappingURL=property-helper.js.map